
<template>
    <div>
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>服务力数据看板</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="area">

            <div class="left">
                <div class="top">
                    <el-form inline label-width="40px">
                        <el-row>
                            <el-form-item label="城市">
                                <el-select v-model="selectQuery.cityId" placeholder="请选择城市" filterable>
                                    <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="驿站">
                                <el-select v-model="selectQuery.postStationId" @change="querySearch2" multiple clearable placeholder="请选择驿站" filterable>
                                    <template v-for="(item,index) in postStationList">
                                        <el-option :key="index" v-if="item.cityId==selectQuery.cityId" :label="item.postStationName" :value="item.id+''"> </el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="服务站">
                                <el-select v-model="selectQuery.stationId" @change="getAllWorker" clearable placeholder="请选择服务站" filterable>
                                    <template v-for="(item,index) in allStationList">
                                        <el-option :key="index" v-if="item.postStationId==addFrom.postStationId" :label="item.stationName" :value="item.id+''"> </el-option>
                                    </template>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="月份">
                                <el-date-picker v-model="selectQuery.month" type="month" value-format="yyyy-MM" placeholder="选择月份">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" plan @click="search">查询</el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>

                    <el-row>
                        <div style="font-size:16px;font-weight:bold;float:left;">
                            <i class="el-icon-collection-tag" style="margin-right:5px"></i>站点数据
                        </div>
                        <br />
                    </el-row>
                    <!-- 库存指标-->
                    <el-row>
                        <div class="zdsj">
                            <div class="dv">
                                <el-row>
                                    <div class="zbsj"><span class="zi">库存指标</span></div>
                                </el-row>
                                <el-row>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.onlineCount}}</font>
                                        <font class="ren">人</font><br />
                                        <div class="sxzrs">上线总人数</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.netIncrease}}</font>
                                        <font class="ren">人</font><br />
                                        <div class="sxzrs">净增长</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.stocklv14}}</font>
                                        <font class="ren">%</font><br />
                                        <div class="sxzrs">14天库存率</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.stocklv7}}</font>
                                        <font class="ren"> %</font><br />
                                        <div class="sxzrs">7天库存率</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.leaveTimes}}</font>
                                        <font class="ren">hours/days</font><br />
                                        <div class="sxzrs">流失者在线时长</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu">{{dataTarget.leaveCounts}}</font>
                                        <font class="ren">人</font><br />
                                        <div class="sxzrs">流失总人数</div>
                                    </div>
                                    <div class="kuang">
                                        <font class="shu" style="color:red;">{{dataTarget.leaveLv}}</font>
                                        <font class="ren" style="color:red;">%</font><br />
                                        <div class="sxzrs">流失率</div>
                                    </div>
                                </el-row>
                            </div>
                            <div class="dv2 bordercolor">
                                <div style="margin-left:1rem;">
                                    <el-row>
                                        <div class="zbsj"><span class="zi">复购指标</span></div>
                                    </el-row>
                                    <el-row>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.day30fyl}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">30天复用率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.day90fyl}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">90天复用率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.fglt7}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">复购率T+7</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.newcustomert7}}</font>
                                            <font class="ren"> %</font><br />
                                            <div class="sxzrs">新客转周期T+7</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.xuyuezhou}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">周期续约率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.xuyue24}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">24次续约率</div>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                            <div class="dv2 bordercolor">
                                <div style="margin-left:1rem;">
                                    <el-row>
                                        <div class="zbsj"><span class="zi">服务指标</span></div>
                                    </el-row>
                                    <el-row>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.serviceOnTime}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">服务准时率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.unusualChangeRatio}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">异常改约占比</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.refundRatio}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">退款率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.orderBadComtRatio}}</font>
                                            <font class="ren"> %</font><br />
                                            <div class="sxzrs">订单差评率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.newWorkerBadComtRatio}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">新人差评率</div>
                                        </div>
                                        <div class="kuang">
                                            <font class="shu">{{dataTarget.oldWorkerBadComtRatio}}</font>
                                            <font class="ren">%</font><br />
                                            <div class="sxzrs">老人差评率</div>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                        </div>
                    </el-row>
                </div>

                <div class="bottom">
                    <el-row>
                        <div style="font-size:16px;font-weight:bold;float:left;">
                            <i class="el-icon-collection-tag" style="margin-right:5px"></i>服务生命力指标
                        </div>
                        <span style="color: #a4a4a4;margin-left:10px;font-size:14px;">指标均为过去30天数据，数据更新可能有延迟</span>
                        <br />
                    </el-row>
                    <!-- 综合健康分 -->
                    <el-row style="margin-top:10px;">
                        <div class="zhjkf">
                            <span style="color:#DEF0FD; line-height: 50px;">综合健康分</span><br />
                            <div style="font-size:34px;margin-top:-10px;">{{avgScore}}分</div>
                            <div style="width:80%;height:18px;margin:10px auto;">
                                <el-progress :text-inside="true" :stroke-width="14" color="#87F7C7" :show-text="false" :percentage="90" status="success"></el-progress>
                            </div>
                            <span style="font-size:20px;">
                                 <span v-if="avgScore>90">优秀</span>
                                <span v-if="avgScore>80&&avgScore<90">良好</span>
                                <span v-if="avgScore<80&&avgScore>70">稳定</span>
                                <span v-if="avgScore<70&&avgScore>60">较稳定</span>
                                <span v-if="avgScore<60" style="color:red">非健康</span>
                            </span>
                        </div>
                        <!-- <div class="mycard">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <el-button type="warning" icon="el-icon-warning-outline" circle></el-button>
                                    <span style="font-weight:bold;font-size:14px;margin-left:10px;">有服务者为潜在流失对象</span>
                                    <el-button style="float: right; padding: 2px 0;font-size:20px;" type="text">×</el-button>
                                </div>
                                <div class="tswz">
                                    列表内容1
                                </div>
                            </el-card>
                        </div>

                        <div class="mycard">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <el-button type="warning" icon="el-icon-warning-outline" circle></el-button>
                                    <span style="font-weight:bold;font-size:14px;margin-left:10px;">有服务者为潜在流失对象</span>
                                    <el-button style="float: right; padding: 2px 0;font-size:20px;" type="text">×</el-button>
                                </div>
                                <div class="tswz">
                                    列表内容1
                                </div>
                            </el-card>
                        </div> -->
 
                    </el-row>

                    <!-- 综合得分列表 -->
                    <el-row style="margin-bottom:20px;">
                      <el-input type="search" placeholder="请输入名字搜索" v-model="searchName" style="width:150px;margin-top:10px;">搜索</el-input>
                      <el-button type="search" @click="querySearch2">搜索</el-button>
                      <el-button type="search" @click="downloadManage">导出</el-button>
                    </el-row>
                    <el-row>
                        <el-table @sort-change="sortChange" :data="listData" border style="width: 100%" class="table">
                            <el-table-column type="index" label="序号" width="55"></el-table-column>
                            <el-table-column prop="worker_name" label="姓名" width="80">
                                <template slot-scope="scope">
                                    <a style="color:#52c0fe;cursor:pointer;" @click="go360(scope.row)">{{scope.row.worker_name}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="city" label="城市" width="80"></el-table-column>
                            <el-table-column prop="post_station" label="驿站"></el-table-column>
                            <el-table-column prop="station" label="服务站"></el-table-column>
                            <el-table-column prop="cancel_time" label="解约状态">
                                <template slot-scope="scope">
                                    <span>{{(scope.row.cancel_time==null||scope.row.cancel_time=='')?'在职':'解约'}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="total_score" label="综合得分" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.total_score}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="work_days_score" label="上线时长" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.work_days_score*100}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="rebuy_score" label="复购" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.rebuy_score*100}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="good_rate_score" label="好评率" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.good_rate_score*100}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="salary_score" label="薪资" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.salary_score*100}}</span>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页 -->
                        <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch2" />

                    </el-row>
                </div>
            </div>

        </div>
    </div>

</template>


<script>
import moment from "moment";
import CircleProgress from "vue-circleprogressbar";
import workercrmapi from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import url from "@/script/baseUrl"

let vm;
export default {
    components: { CircleProgress, Pagination },

    data() {
        return {
              exportManageUrl:
                url.salaryUrl +
                "/managerView/workerLifeIndicators?token=" +
                window.localStorage.getItem("token"),
            listData: [],
            avgScore: null,
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页

            cityList: [],
            postStationList: [],
            allStationList: [],

            dataTarget: {
                day30fyl: null, //#30天复用率
                day90fyl: null, //#90天复用率
                fglt7: null, //#复购率T+7
                leaveCounts: null, //流失总人数
                leaveLv: null, //流失率
                leaveTimes: null, //流失者
                // months: null,
                netIncrease: null, //净增长人数
                newWorkerBadComtRatio: null, //新人差评率
                newcustomert7: null, //新客转周期T+7
                oldWorkerBadComtRatio: null, //老人差评率
                onlineCount: null, //上线总人数
                orderBadComtRatio: null, //订单差评率
                refundRatio: null, //退款率
                serviceOnTime: null, //服务准时率
                stocklv7: null, //库存率7
                stocklv14: null, //库存率14
                unusualChangeRatio: null, //异常改约占比
                xuyue24: null, //24次续约率
                xuyuezhou: null, //周期续约率
            },
            selectQuery: {
                month: null,
                cityId: null,
                postStationId: [],
                stationId: null,
            },
            pickerOptions: {
                disabledDate(time) {
                    let flag = false;
                    flag =
                        moment(time) > moment().add(1, "month") ||
                        moment(time) < moment().subtract(6, "month");
                    return flag;
                },
            },
          searchName:''
        };
    },
    created() {
        this.getAllCity();
        this.getAllPostStation();

        this.querySearch();
        this.querySearch2();
    },
    methods: {
        go360(row) {
            console.log(row);
            this.$router.push({
                path: "/worker360View",
                query: {
                    workerNo: row.worker_no,
                },
            });
        },
        search(){
            this.querySearch();
            this.querySearch2();
        },
        querySearch() {
            let req = {
                month: this.selectQuery.month,
                cityId: this.selectQuery.cityId,
                postId: this.selectQuery.postStationId.join(","),
            };
            workercrmapi
                .$axiosManagerViewGetManagerboardData(req)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.dataTarget = res.data.data;
                    }
                });
        },
        querySearch2() {

            let req = {
                cityId:
                    this.selectQuery.cityId == null
                        ? "2"
                        : this.selectQuery.cityId,
                postId: this.selectQuery.postStationId.join(","),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            };
            if(this.searchName){
                req.searchName = this.searchName;
            }
            workercrmapi
                .$axiosManagerViewWorkerLifeIndicators(req)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.detail.list;
                        this.avgScore = res.data.data.avgScore;
                        this.total = res.data.data.detail.total;
                    }
                });
        },
        downloadManage(){
            let cityId=(this.selectQuery.cityId == null? "2": this.selectQuery.cityId);
             let params = `&export=1&cityId=${cityId}&postId=${this.selectQuery.postStationId.join(",")}&pageSize=${this.pageSize}&pageNum=${this.currentPage}&searchName=${this.searchName}`;
            window.open(this.exportManageUrl + params);
        },
        sortChange(e) {
            console.log(e);
        },
        getAllPostStation() {
            //驿站
            workercrmapi.$axiosPostStationgetAllList().then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
    },
};
</script>


<style lang="scss" scoped>
.area {
    display: flex;
    margin: 10px;
    font-family: "Microsoft YaHei", 微软雅黑;
    min-width: 1200px;
}

.area .left {
    flex: 7;
    flex-direction: column;
}
.area .left .top {
    // flex: 2;
    background-color: white;
    flex-direction: row-reverse;
    border-radius: 10px;
    padding: 20px;
}
.area .left .bottom {
    margin-top: 20px;
    // flex: 6;
    background-color: white;
    flex-direction: row-reverse;
    border-radius: 10px;
    padding: 20px;
}

.zdsj {
    width: 100%;
    height: 12rem;
    // border: 1px solid red;
    padding: 5px;
    margin-top: 10px;
}
.zdsj .dv {
    float: left;
    width: 30.5rem;
    height: 11rem;
    margin-left: 0rem;
    // border:1px solid green;
}

.zdsj .dv2 {
    float: left;
    width: 23rem;
    height: 11rem;
    margin-left: 0rem;
    // border:1px solid green;
}
.bordercolor {
    border-left: 2px solid #f2f2f2;
}
.zbsj {
    // border:1px solid green;
    width: 100px;
    padding: 8px;
    text-align: center;
    margin-bottom: 5px;
    // height:30px;
    background: linear-gradient(to left, #52c0fe, #52c0fe) left top no-repeat,
        linear-gradient(to bottom, #52c0fe, #52c0fe) left top no-repeat,
        linear-gradient(to left, #52c0fe, #52c0fe) right top no-repeat,
        linear-gradient(to bottom, #52c0fe, #52c0fe) right top no-repeat,
        linear-gradient(to left, #52c0fe, #52c0fe) left bottom no-repeat,
        linear-gradient(to bottom, #52c0fe, #52c0fe) left bottom no-repeat,
        linear-gradient(to left, #52c0fe, #52c0fe) right bottom no-repeat,
        linear-gradient(to left, #52c0fe, #52c0fe) right bottom no-repeat;
    background-size: 2px 10px, 10px 2px, 2px 10px, 10px 2px;
}
.zbsj .zi {
    background: #edf8ff;
    color: #42afff;
    padding: 4px 10px 4px 10px;
}
.kuang {
    width: 7rem;
    height: 4rem;
    border: 2px dashed #87ccff;
    margin-right: 0.2rem;
    margin-top: 0.3rem;
    float: left;
    text-align: center;
    // line-height: 20px;
    // border-right: 0px;
}
.kuang .shu {
    font-size: 18px;
    font-weight: bold;
    line-height: 50px;
    color: #66bbf9;
}
.kuang .ren {
    font-size: 12px;
    color: #66bbf9;
}
.kuang .sxzrs {
    font-size: 12px;
    margin-top: -15px;
    color: #a4a4a4;
}
.zhjkf {
    width: 150px;
    height: 170px;
    background: #66bbf9;
    border-radius: 20px;
    text-align: center;
    color: white;
    float: left;
    margin-bottom: 30px;
}

.box-card {
    width: 320px;
}

.tswz {
    font-size: 14px;
    color: #a4a4a4;
}
.mycard {
    float: left;
    margin-left: 30px;
}
.mycard .el-card .box-card .is-always-shadow .el-card__header {
    padding: 10px 20px;
}
</style>


>>>>>>> branch 'worker-crm' of http://47.102.110.240:3000/yuxiangpei/jzlife_vue_servant.git
